document.addEventListener('DOMContentLoaded', function () {

  function pad(n) { return String(n).padStart(2, '0'); }

  document.querySelectorAll('[data-drop-countdown]').forEach(function (el) {
    var targetRaw = el.getAttribute('data-drop-start');
    if (!targetRaw) return;

    var target = new Date(targetRaw.replace(' ', 'T')).getTime();
    if (isNaN(target)) return;

    var daysEl = el.querySelector('[data-countdown-days]');
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minsEl = el.querySelector('[data-countdown-minutes]');
    var secsEl = el.querySelector('[data-countdown-seconds]');
    var labelEl = el.querySelector('[data-countdown-label]');

    function tick() {
      var diff = target - Date.now();

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minsEl) minsEl.textContent = '00';
        if (secsEl) secsEl.textContent = '00';
        if (labelEl) labelEl.textContent = 'Happening now';
        clearInterval(timer);
        document.dispatchEvent(new CustomEvent('drop:ended'));
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(minutes);
      if (secsEl) secsEl.textContent = pad(seconds);
    }

    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---------- What happens when the drop window closes ----------
     The section already declines to render an expired banner, but a page served
     from cache was rendered while the drop was still open, so the check is
     repeated here. Normally the bar simply retires itself rather than sitting at
     00d 00h 00m 00s. It only stays put to explain the closure when it is also
     gating the cart, which is opt-in via the Drop banner section. */
  var banner = document.querySelector('[data-drop-banner]');
  if (banner) {
    var locksCart = banner.hasAttribute('data-drop-lock-cart');
    var endRaw = banner.getAttribute('data-drop-end');
    var endTime = endRaw ? new Date(endRaw.replace(' ', 'T')).getTime() : NaN;

    function lockCheckout() {
      banner.classList.add('is-closed');
      var closedEl = banner.querySelector('[data-drop-closed]');
      if (closedEl) closedEl.hidden = false;

      document.querySelectorAll('[data-add-to-cart], [data-add-stack], button[name="checkout"]').forEach(function (btn) {
        btn.disabled = true;
        btn.textContent = 'Drop closed';
      });
      document.querySelectorAll('a[href*="/checkout"]').forEach(function (link) {
        link.classList.add('is-disabled');
        link.setAttribute('aria-disabled', 'true');
        link.addEventListener('click', function (e) { e.preventDefault(); });
      });
    }

    function closeDrop() {
      if (locksCart) {
        lockCheckout();
      } else {
        banner.hidden = true;
      }
    }

    if (isNaN(endTime)) {
      // No date set, so there is no deadline to announce.
      banner.hidden = true;
    } else if (Date.now() >= endTime) {
      closeDrop();
    }
    document.addEventListener('drop:ended', closeDrop);
  }
});
